import BannerNavItem from './BannerNavItem';

export default BannerNavItem;
